define('formsBase',["jquery", "underscore"], function ($, _) {
    "use strict";

    function FormsBase() { }

    FormsBase.prototype.getAjaxErrorResult = function getAjaxErrorResult(xhr) {
        var result = {};
        if (xhr.status === 400) {
            var errors = xhr.responseJSON;
            if (errors && typeof errors === "object") {
                result = _.pluck(errors, "Message");
            } else {
                var errObj = $.parseJSON(errors);
                result = _.pluck(errObj, "Message");
            }
        }
        if (xhr.status === 500) {
            var json = $.parseJSON(xhr.responseText);
            if (json) {
                console.log(json.Message || json);
            }
        }
        return result;
    }

    return new FormsBase();
});
